import * as yup from 'yup'

export const UpdateMarketplaceDataFormSchema = yup.object({
  shouldSyncMcNumber: yup.boolean(),
  shouldSyncEin: yup.boolean(),
  shouldSyncLegalName: yup.boolean(),
  shouldSyncDbaName: yup.boolean(),
  shouldSyncPhysicalAddress: yup.boolean(),
  shouldSyncContactName: yup.boolean(),
  shouldSyncContactEmail: yup.boolean(),
  shouldSyncContactPhone: yup.boolean(),
})

export type TUpdateMarketplaceDataFormSchema = yup.InferType<typeof UpdateMarketplaceDataFormSchema>
